exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-invitation-logo-425rg0Yomwr{height:40px}.app-invitation-invitation-text-3PsqpaCOmwr{font-size:14px;line-height:20px;word-wrap:break-word}.app-invitation-actions-4D9wErw3mwr{display:flex;align-items:baseline}.app-invitation-actions-4D9wErw3mwr .app-invitation-decline-1sEIxHupmwr{color:var(--secondary-text);margin-left:20px;font-size:12px}.app-invitation-success-1GUzuiimmwr,.app-invitation-alert-2iRixNS7mwr{margin-top:40px;margin-bottom:1em;padding:40px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"logo": "app-invitation-logo-425rg0Yomwr",
	"invitation-text": "app-invitation-invitation-text-3PsqpaCOmwr",
	"invitationText": "app-invitation-invitation-text-3PsqpaCOmwr",
	"actions": "app-invitation-actions-4D9wErw3mwr",
	"decline": "app-invitation-decline-1sEIxHupmwr",
	"success": "app-invitation-success-1GUzuiimmwr",
	"alert": "app-invitation-alert-2iRixNS7mwr"
};